// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CommitmentsForChangeEvent_Commitment_Fragment = { __typename?: 'Commitment', id: string, accountingNumber: number, committedInCents: number, displayName: string, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, statusText: string, updatedAt: Types.Scalars['DateTime']['input'], blueprintUrl: { __typename?: 'Url', path: string }, commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, costCode: { __typename?: 'CostCode', id: string, number: string } }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined };

export type CommitmentsForChangeEvent_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, committedInCents: number, displayName: string, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, statusText: string, updatedAt: Types.Scalars['DateTime']['input'], blueprintUrl: { __typename?: 'Url', path: string }, commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, costCode: { __typename?: 'CostCode', id: string, number: string } }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined };

export type CommitmentsForChangeEventFragment =
  | CommitmentsForChangeEvent_Commitment_Fragment
  | CommitmentsForChangeEvent_CommitmentChangeOrder_Fragment
;

export type CommitmentsForChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type CommitmentsForChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, commitments: Array<
      | { __typename?: 'Commitment', id: string, accountingNumber: number, committedInCents: number, displayName: string, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, statusText: string, updatedAt: Types.Scalars['DateTime']['input'], blueprintUrl: { __typename?: 'Url', path: string }, commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, costCode: { __typename?: 'CostCode', id: string, number: string } }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }
      | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, committedInCents: number, displayName: string, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, statusText: string, updatedAt: Types.Scalars['DateTime']['input'], blueprintUrl: { __typename?: 'Url', path: string }, commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, costCode: { __typename?: 'CostCode', id: string, number: string } }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }
    > } };

export const CommitmentsForChangeEventFragmentDoc = gql`
    fragment CommitmentsForChangeEvent on CommitmentLike {
  id
  accountingNumber
  blueprintUrl {
    path
  }
  commitmentType {
    code
    name
  }
  committedInCents
  displayName
  executionDate
  lineItems {
    id
    costCode {
      id
      number
    }
  }
  status
  statusText
  tradePartner {
    ...Named
  }
  updatedAt
}
    ${NamedFragmentDoc}`;
export const CommitmentsForChangeEventDocument = gql`
    query CommitmentsForChangeEvent($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    id
    commitments {
      ...CommitmentsForChangeEvent
    }
  }
}
    ${CommitmentsForChangeEventFragmentDoc}`;

/**
 * __useCommitmentsForChangeEventQuery__
 *
 * To run a query within a React component, call `useCommitmentsForChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommitmentsForChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitmentsForChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useCommitmentsForChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables> & ({ variables: CommitmentsForChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>(CommitmentsForChangeEventDocument, options);
      }
export function useCommitmentsForChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>(CommitmentsForChangeEventDocument, options);
        }
// @ts-ignore
export function useCommitmentsForChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>;
export function useCommitmentsForChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommitmentsForChangeEventQuery | undefined, CommitmentsForChangeEventQueryVariables>;
export function useCommitmentsForChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>(CommitmentsForChangeEventDocument, options);
        }
export type CommitmentsForChangeEventQueryHookResult = ReturnType<typeof useCommitmentsForChangeEventQuery>;
export type CommitmentsForChangeEventLazyQueryHookResult = ReturnType<typeof useCommitmentsForChangeEventLazyQuery>;
export type CommitmentsForChangeEventSuspenseQueryHookResult = ReturnType<typeof useCommitmentsForChangeEventSuspenseQuery>;
export type CommitmentsForChangeEventQueryResult = ApolloReactCommon.QueryResult<CommitmentsForChangeEventQuery, CommitmentsForChangeEventQueryVariables>;